export enum SubscriptionChangeStatus {
  Success = 'success',
  RequiresPaymentMethod = 'requires-payment-method',
  RequiresAction = 'requires-action',
  Unknown = 'unknown',
}

export interface ChangeSubscriptionFnReq {
  priceId: string;
  /** UNIX epoch in seconds */
  prorationDate: number;
}

interface ChangeSubscriptionFnSuccessRes {
  status: SubscriptionChangeStatus.Success;
}

interface ChangeSubscriptionFnRequiresPaymentMethodRes {
  status: SubscriptionChangeStatus.RequiresPaymentMethod;
  portalUrl: string;
}

interface ChangeSubscriptionFnRequiresActionRes {
  status: SubscriptionChangeStatus.RequiresAction;
  clientSecret: string;
}

interface ChangeSubscriptionFnUnknownRes {
  status: SubscriptionChangeStatus.Unknown;
}

export type ChangeSubscriptionFnRes =
  | ChangeSubscriptionFnSuccessRes
  | ChangeSubscriptionFnRequiresPaymentMethodRes
  | ChangeSubscriptionFnRequiresActionRes
  | ChangeSubscriptionFnUnknownRes;
